/**
 * Cookie Notice user choice
 * @author Frédéric Pineau
 * modifié par artwaï pour artwaï
 */

 (function () {

    const labels = {
        'stats_nochoice': 'Vous n\'avez pas encore fait de choix concernant les cookies statistiques. ',
        'stats_validate': 'Vous avez explicitement accepté les cookies statistiques sur ce site, ',
        'stats_invalidate': 'Vous avez refusé l\'usage des cookies pour les statistiques et de mesures d\'audience du site, ',
        'video_nochoice': 'Vous n\'avez pas encore fait de choix concernant les cookies videos. Ce choix vous sera proposé au moment opportun. ',
        'video_validate': 'Vous avez explicitement accepté les cookies provenant de(s) service(s) vidéo(s) suivant(s)&nbsp;: <br class="hide-xs" />'
    };

    function readCookie(cookieName) {
        const re = new RegExp('[; ]' + cookieName + '=([^\\s;]*)');
        const sMatch = (' ' + document.cookie).match(re);
        if (cookieName && sMatch) {
            cookieObj = JSON.parse(sMatch[1]);
            if(typeof cookieObj === 'object' && cookieObj !== null) {
                return cookieObj;
            }
        }

        return 'invalidate';
    }
    
    function deleteCookie(cookieName) {
        document.cookie = cookieName + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;';
    }
    
    function createDismissButton(message, buttonClass) {
        const dismissButton = document.createElement('a');

        // Dismiss button
        dismissButton.href = '#';
        dismissButton.innerHTML = message;
        dismissButton.style.padding = '4px 1em';
        dismissButton.style.height = 'auto';
        dismissButton.style.verticalAlign = 'middle';
        dismissButton.className = buttonClass;

        return dismissButton;
    }

    function addSuffixDate(cookieObj) {
        var suffixDate = "";
        if(typeof cookieObj === 'object' && cookieObj !== null) {
            var dateBegin = new Date(cookieObj.datebegin);
            var dayBegin = dateBegin.getDate();
            var monthBegin = dateBegin.toLocaleString('default', { month: 'long' });
            var yearBegin = dateBegin.getFullYear();

            var dateExpires = new Date(cookieObj.dateexpires);
            var dayExpires = dateExpires.getDate();
            var monthExpires = dateExpires.toLocaleString('default', { month: 'long' });
            var yearExpires = dateExpires.getFullYear();

            suffixDate = "du " + dayBegin + " " + monthBegin + " " + yearBegin + " jusqu'au " + dayExpires + " " + monthExpires + " " + yearExpires + ". ";
        }

        return suffixDate;
    }

    //-------------------------------------------------- consent_statistiques

    const consentStatsObj = readCookie('consent_statistiques');
    const consentStatsValue = consentStatsObj.value;

    const containerNotice = document.getElementById("consent_statistiques_user_choice");
    containerNotice.className = 'bg-2 text-center';
    containerNotice.style.padding = '1em';

    const dismissButton = createDismissButton('Changer d\'avis', 'bg-9 btn');

    dismissButton.addEventListener('click', e => {
        e.preventDefault();
        deleteCookie('consent_statistiques');
        document.location.reload();
    });

    const br = document.createElement('br');
    br.className = 'visible-xs';

    if (consentStatsValue == "0") {
        containerNotice.innerHTML = labels.stats_invalidate + addSuffixDate(consentStatsObj);
        containerNotice.appendChild(br);
        containerNotice.appendChild(dismissButton);
    }
    else if (consentStatsValue == "1") {
        containerNotice.innerHTML = labels.stats_validate + addSuffixDate(consentStatsObj);
        containerNotice.appendChild(br);
        containerNotice.appendChild(dismissButton);
    }
    else {
        containerNotice.innerHTML = labels.stats_nochoice;
    }
    
    //-------------------------------------------------- consent_videos
    
    let consentVideosObj = readCookie('consent_videos');
    const consentVideosValue = consentVideosObj.value;

    const container = document.getElementById("consent_videos_user_choice");
    if(container) {
        container.className = 'bg-2 text-center';
        container.style.padding = '1em';

        const dismissButton = createDismissButton('Supprimer', 'bg-9 btn');

        dismissButton.addEventListener('click', e => {
            e.preventDefault();
            deleteCookie('consent_videos');
            document.location.reload();
        });

        const br = document.createElement('br');
        br.className = 'visible-xs';


        if (consentVideosObj != 'invalidate') {
            container.innerHTML = labels.video_validate;
            
            var listHtml = '<ul style="list-style-position: inside;margin-bottom: 0">';
            for (var consentvideo in consentVideosObj) {
                listHtml += "<li>" + consentvideo + ", " + addSuffixDate(consentVideosObj[consentvideo]) + "</li>";
            }
            listHtml += '</ul>';

            container.innerHTML += listHtml;

            container.appendChild(br);
            container.appendChild(dismissButton);
        }
        
        else {
            container.innerHTML = labels.video_nochoice;
        }
    }

    
}());